import "./jquery-3.3.1.min"
import "./jquery.event.move";
import "./jquery.twentytwenty";
import "./swiper";
import "./jquery.fancybox.min";